// import React, { useState } from "react";
// import ActiveInActiveButton from "./ActiveInActiveButton";

// interface MultiSelectGridProps {
//   items: { id: number; label: string }[];
//   label: string;
// }

// const MultiSelectGrid: React.FC<MultiSelectGridProps> = ({ items, label }) => {
//   const [selectedItems, setSelectedItems] = useState<number[]>([]);

//   const handleSelect = (id: number) => {
//     setSelectedItems((prev) =>
//       prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
//     );
//   };

//   return (
//     <div style={{ width: "90%", background: "#fff", padding: 30 }}>
//       <p style={{ fontSize: 18, fontFamily: "Gilroy-Regular" }}>{label}</p>

//       <div
//         style={{
//           display: "flex",
//           flexWrap: "wrap",
//           justifyContent: "space-between",
//           gap: "8px",
//           width: "100%",
//           margin: "auto",
//         }}
//       >
//         {items.map((item) => (
//           <ActiveInActiveButton
//             key={item.id}
//             mainText={item.label}
//             selected={selectedItems.includes(item.id)}
//             onPress={() => handleSelect(item.id)}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default MultiSelectGrid;
import React, { useState } from "react";
import ActiveInActiveButton from "./ActiveInActiveButton";
import useCustomStyles from "../../../hooks/useCustomStyles";
import { useSelector } from "react-redux";
import { selectState } from "../../../store/slices/themeSlice";
import { multiSelectGridStyles } from "../../../assets/styles/ClientsStyles/multiSelectGridStyles";

interface MultiSelectGridProps {
  items: { id: number; label: string }[];
  label: string;
}

const MultiSelectGrid: React.FC<MultiSelectGridProps> = ({ items, label }) => {
  const [selectedItems, setSelectedItems] = useState<number[]>([]);
  const { theme } = useSelector(selectState);
  const classes = useCustomStyles(multiSelectGridStyles, theme);

  const handleSelect = (id: number) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  return (
    <div className={classes.container}>
      <p className={classes.label}>{label}</p>

      <div className={classes.gridContainer}>
        {items.map((item) => (
          <div key={item.id} className={classes.buttonWrapper}>
            <ActiveInActiveButton
              mainText={item.label}
              selected={selectedItems.includes(item.id)}
              onPress={() => handleSelect(item.id)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MultiSelectGrid;
